/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ContractValidity = 'Incomplete' | 'Active' | 'Expired';

export const ContractValidity = {
    Incomplete: 'Incomplete' as ContractValidity,
    Active: 'Active' as ContractValidity,
    Expired: 'Expired' as ContractValidity
};

